/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BtnWhatsapp.vue?vue&type=template&id=cb5a63ee&"
import script from "./BtnWhatsapp.vue?vue&type=script&lang=js&"
export * from "./BtnWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports